module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Danksagung")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("JEANNIE, MEINE")]), _vm._v(" Freundin und Zeichensetzungs-Guru. Danke für deine Unterstützung und Hingabe. Durch dich ist es so viel leichter.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Ann, Jackie, Lyn und Sharon. Kritiker, die sich nie scheuen, mir zu sagen, wenn ich einen Fehler gemacht habe, und mir den Kopf tätscheln, wenn ich es nötig habe.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Marita, die außergewöhnliche Videomacherin. Dein Talent inspiriert mich. Danke, dass du es mit mir teilst.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Reese Dante. Dein Auge fürs Detail ist legendär. Vielen Dank für mein wunderschönes Buchcover.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Zu guter Letzt den wundervollen Leuten von Dreamspinner Press, die immer da sind, wenn man sie braucht. Danke!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dc1f7f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0004.vue
// module id = 66
// module chunks = 0